module.exports = __webpack_public_path__ + "1f352eaa2b16e5684b287e37f1e415af.svg";